//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    function isios(){
        if(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){
            return true
        }else{
            return false
        }
    }
    import dockingItem from '@/crowd_fund/docking/dockingItem'
    import headers from '@/components/header/headerBackTitle'
	export default{
		components: {
            dockingItem,
            headers
		},
		props:['epId'],
		data() {
			return {
				rankType: [{id: 1, name: '进行中'}, {id: 2, name: '已完成'}],
				typeBoolean: false,
				queryState: 1,//查询状态 1是进行中，2是已完成
				isFirst: true, //是否第一次切换
				finishList: [], //已完成数据
				List: [], //进行中数据
				sortIndex:1,
				typeIndex:0,
                listTotal:'',
                showconPay:false,
                list:{}
			}
		},
		methods: {
            itemLink(list){
                this.list=list
                this.helpLink()
            },
            confirmLoginFun(){
                this.payIsNShow = false
                window.android.login()
            },
            cancelLoginFun(){
                this.payIsNShow = false
                localStorage.setItem("isFirstPay",1)
            },
            onConfirm() {
                this.showconPay = false
                window.android.login()
            },
            helpLinkAnonymous(){
            // 资金需求的匿名捐
                this.showconPay = false
                if (this.list.demand_type == 2) {
                    if(this.list.operational_review_status !=1 || this.list.operational_review_status != 2){
                        console.log('111isios',isios(),'-',this.BF_PAY_URL +"/payview/helphe.html?isN=1&demand_code=" +
                            this.list.id +
                            "&userid=" + process.env.anonymousUserid+
                            "&token=" + localStorage.getItem("token")+ "&payname=" + process.env.MCHTYPEH5+ "&jdomain=" +this.BASE_URL+"&path="+this.$route.path)
                        if (isios()) {
                            localStorage.setItem('isFirstPay',2)
                            let linkStr=this.BF_PAY_URL +"/payview/helphe.html?isN=1&demand_code=" +
                            this.list.id +
                            "&userid=" + process.env.anonymousUserid+
                            "&token=" + localStorage.getItem("token")+ "&payname=" + process.env.MCHTYPEH5+ "&jdomain=" +this.BASE_URL+"&path="+this.$route.path+'?acr001='+this.$route.query.acr001;
                                window.native.appLoadUrl(linkStr)
                        } else{
                            console.log(this.BF_PAY_URL+"/gzddpt/#/helpHe/" + this.list.id + "/" + this.list.aideder_name+'?isN=1')
                            let url=this.BF_PAY_URL+"/gzddpt/#/helpHe/" + this.list.id + "/" + this.list.aideder_name+'?isN=1'
                            localStorage.payUrlLink=url
                            window.location.href=url
                            // this.$router.push("/helpHe/" + this.list.id + "/" + this.list.aideder_name+'?isN=1');
                        }
                    }
                } else {
                    this.showToast("", "text", "获取类型失败", "", "middle");
                }
            },
            closeConPay(){
                this.showconPay = false
            },
            helpLink() {
                //判断用户是否登录
                let isLogin = localStorage.getItem("token");
                console.log(isLogin)
                if(this.isWeixinCient()){
                    if (this.list.demand_type == 1) {
                        window.location.href=this.appjump_url+"/gzddpt/#/helpHeGoods/" + this.list.id + "/" + this.list.aideder_name
                    } else if (this.list.demand_type == 2) {
                        window.location.href=this.appjump_url+"/gzddpt/#/helpHe/" + this.list.id + "/" + this.list.aideder_name
                    } else {
                        this.showToast("", "text", "获取类型失败", "", "middle");
                    }
                }else{
                    if (this.zctoken == '(null)' || this.zctoken == undefined || this.zctoken == 'undefined' || this.zctoken == '' || this.zctoken == null || this.zctoken == 'null') {
                        if (this.list.demand_type == 1) {
                            // 物品
                            this.showconfirm = true
                            this.cont = '您还未登录，请登录后关注！'
                        }else if(this.list.demand_type == 2){
                            this.showconPay = true
                        } else {
                            this.showToast("", "text", "获取类型失败", "", "middle");
                        }
                    } else {
                        if (this.list.demand_type == 1) {
                            if(this.list.ispoorself != 1){
                                if(this.list.operational_review_status !=1 || this.list.operational_review_status != 2){
                                    this.$router.push(this.BF_PAY_URL+"/gzddpt/#/helpHeGoods/" + this.list.id + "/" + this.list.aideder_name);
                                }
                            }else{
                                this.showToast("", "text", "不能帮扶自己发布的需求", "", "middle");
                            }
                        } else if (this.list.demand_type == 2) {
                            if(this.list.operational_review_status !=1 || this.list.operational_review_status != 2){
                                console.log('isios',isios())
                                if (isios()) {
                                    let linkStr=this.BF_PAY_URL +"/payview/helphe.html?demand_code=" +
                                    this.list.id +
                                    "&userid=" + this.userid+
                                    "&token=" + this.zctoken+ "&payname=" +this.MCHTYPEH5+ "&jdomain=" +this.BASE_URL+"&path="+this.$route.path+'?acr001='+this.$route.query.acr001;
                                    console.log('linkStr',linkStr)
                                    window.native.appLoadUrl(linkStr)
                                } else{   
                                    console.log(this.BF_PAY_URL+"/gzddpt/#/helpHe/" + this.list.id + "/" + this.list.aideder_name)
                                    window.location.href=this.BF_PAY_URL+"/gzddpt/#/helpHe/" + this.list.id + "/" + this.list.aideder_name+"?userid="+this.userid
                                }
                            }
                        } else {
                            this.showToast("", "text", "获取类型失败", "", "middle");
                        }
                    }
                }
            },
            goPover(){
                let zcuserid=this.$route.params.zcuserid
                let zcnickname=this.$route.params.zcnickname
                let zctoken=this.$route.params.zctoken
                this.$router.push('/poverty/'+zcuserid+'/'+zcnickname+'/'+zctoken)
            },
			tab(index) {
				if(this.typeIndex !== index){
					this.typeBoolean = !this.typeBoolean
					this.typeIndex = index
					if(index==0) {
		        this.queryState = 1;
		      }else {
		        this.queryState = 2;
		      }
					if(this.isFirst) {
						this.isFirst = false
						this.getList()
					}
				}
			},
			refresh (done) {
                setTimeout(() => {
                    this.sortIndex = 1
                        this.List=[]
                        this.getList();
                        done()
                }, 1000)
			},
			infinite (done) {
		 		setTimeout(() => {
		 			if(this.queryState == 1){
                        if(this.unfinishList.length < this.listTotal) {
                            this.sortIndex++
                                this.getList(done);
                        }else {
                            done(true)
                        }
                    }else {
                        if(this.finishList.length < this.listTotal) {
                            this.sortIndex++
                                this.getList(done);
                        }else {
                            done(true)
                        }
                    }
		 		}, 1000)
			},
			getList(done) {
                let proId=this.$route.query.acr001
                // let proId=999888
                this.$https.post(this.BASE_URL+"/hts/crowddemand/getCrowdDemanList?crowdId="+proId,).then(res => {
                    this.List.push(...res.data.data.vos)
                    this.listTotal = res.data.data.total
                    if(done){
                        done(true)
                    }
                })
                .catch(function(err) {
                    console.log(err);
                })
			}
		},
		created() {
            this.zctoken=this.$route.params.zctoken
            this.userid=this.$route.params.zcuserid
            console.log(this.$route.query,this.$route.params)
            if(localStorage.getItem("isFirstPay") == 1 || localStorage.getItem("isFirstPay") == '1'){
                this.payIsNShow = false
            }else{
                if(this.$route.query.payIsN == "false" || this.$route.query.payIsN == undefined){
                    this.payIsNShow = false
                }else {
                    this.payIsNShow = true
                }
            }
			this.getList()
		}
	}



// WEBPACK FOOTER //
// ./src/crowd_fund/docking/dockingList.vue